"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NoActiveSubscriptions = exports.InvalidPackage = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const openapi_1 = require("../../../openapi");
const Vending = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Frontend.Vending.Spec';
const DrinkListResponse = openapi_1.Response.Success(Vending.DrinkListData).annotations({
    description: 'Drink list',
});
const StripeConfigResponse = openapi_1.Response.Success(Vending.StripeConfig).annotations({
    description: 'Stripe client configuration',
});
const PackageListResponse = openapi_1.Response.Success(Vending.PackageListData).annotations({
    description: 'Available subscription packages',
});
const OrderResponse = openapi_1.Response.Success(Vending.Order).annotations({
    description: 'Subscription package order',
});
const CreatedOrderResponse = openapi_1.Response.Success(Vending.CreatedOrder).annotations({
    description: 'Created subscription package order',
});
exports.InvalidPackage = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.InvalidPackage`, 'INVALID_PACKAGE', 'Invalid Package', 'The package id could not be read: it does not exist, or reading it failed. Carries no express-validator field errors.');
const CommandSentResponse = openapi_1.Response.EmptyData.annotations({
    description: 'The request was accepted; neither sending nor delivery of the command is confirmed',
});
exports.NoActiveSubscriptions = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({ message: effect_1.Schema.Literal('NO_ACTIVE_SUBSCRIPTIONS') }),
}).annotations({
    identifier: `${exports.NAMESPACE}.NoActiveSubscriptions`,
    title: 'No Active Subscriptions',
    description: 'The user has no active subscription of type pelican. Not an express-validator error and not the guard 403.',
    [platform_1.HttpApiSchema.AnnotationStatus]: 403,
});
const accepted = 'The 200 means the request was accepted. Neither sending nor delivery of the command is confirmed: a device that is offline or does not accept it still gets 200, because the result of sending is not read, so a failed send is not a 500. The 500 comes from a device with no IoT Hub assigned or an unexpected failure.';
const otpSession = 'The session id is the rolling OTP from the QR code of the machine, and the machine verifies it.';
/** No 429 on any vending route: the router uses `NullRateLimiter`. */
const publicErrors = openapi_1.Error.withErrors([openapi_1.Error.V1Internal]);
const userErrors = openapi_1.Error.withErrors([
    openapi_1.Error.V1NotAuthenticated,
    openapi_1.Error.V1Forbidden,
    openapi_1.Error.V1Internal,
]);
const getDrinkList = platform_1.HttpApiEndpoint.get('getDrinkList') `/drink-list`
    .setUrlParams(Vending.DrinkListQuery)
    .addSuccess(DrinkListResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Get Drink List')
    .annotate(platform_1.OpenApi.Description, 'Returns the catalog of enhanced drinks: the whole enhancement catalog, or, with serialNumber, the drinks installed in that machine that are not depleted or expired, together with its point-of-sale setting. A serialNumber that is not a string is a 422. Known bug: the consumable repository the catalog reads from is not implemented ("Not implemented"), so a valid request is answered with 500 and the 200 body below is the intended shape, not one that is returned today. An unknown serialNumber is also a 500, not a 404. Entries have no consumable link the catalog lookup needs, and the enhancement branch filters on the lower-case kind "enhancements" while the category is "Enhancements".')
    .pipe(openapi_1.Security.Public, publicErrors);
const getStripeConfig = platform_1.HttpApiEndpoint.get('getStripeConfig') `/store/stripe/config`
    .setUrlParams(Vending.StripeConfigQuery)
    .addSuccess(StripeConfigResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Get Stripe Client Configuration')
    .annotate(platform_1.OpenApi.Description, 'Returns the Stripe publishable key that client applications use to set up the Stripe SDK. An appId that is missing, or is not a registered, enabled client application, is a 422.')
    .pipe(openapi_1.Security.Public, publicErrors);
const listSubscriptionPackages = platform_1.HttpApiEndpoint.get('listSubscriptionPackages') `/store/subscription/packages`
    .setUrlParams(Vending.PackageListQuery)
    .addSuccess(PackageListResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'List Subscription Packages')
    .annotate(platform_1.OpenApi.Description, 'Returns the enabled subscription packages, filtered by type, currency, country and language when those are given. The price and texts are returned for the requested currency and language (USD and en by default). An invalid appId, countryCode or lang is a 422. A package that matches the filters but has no text field in that language gets null for it.')
    .pipe(openapi_1.Security.Public, publicErrors);
const getSubscriptionOrder = platform_1.HttpApiEndpoint.get('getSubscriptionOrder') `/store/subscription/order`
    .setUrlParams(Vending.OrderQuery)
    .addSuccess(OrderResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(openapi_1.Error.V1NotAuthorized)
    .middleware(openapi_1.Security.V1AuthenticatedUser)
    .annotate(platform_1.OpenApi.Title, 'Get Subscription Order')
    .annotate(platform_1.OpenApi.Description, 'Returns the state of a subscription package order, a Stripe payment intent. Checks run in this order: an orderId that is missing or not a string is a 422; an order Stripe cannot return, or one whose metadata has no package id or whose package no longer exists, is a 404; an order that belongs to another user is a 401 with INVALID_CREDENTIALS. Stripe succeeded and canceled are returned as they are, any other Stripe status, including processing, as pending. Reading an order that has succeeded also writes the subscription for the user and package, expiring after the days of the package. If the write fails the answer is 500 although the payment went through.')
    .pipe(userErrors);
const createSubscriptionOrder = platform_1.HttpApiEndpoint.post('createSubscriptionOrder') `/store/subscription/order`
    .setPayload(Vending.CreateOrderPayload)
    .addSuccess(CreatedOrderResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(exports.InvalidPackage)
    .middleware(openapi_1.Security.V1AuthenticatedUser)
    .annotate(platform_1.OpenApi.Title, 'Create Subscription Order')
    .annotate(platform_1.OpenApi.Description, 'Creates a Stripe payment intent for a subscription package and returns what the client SDK needs to take the payment. A packageId that is empty or not a string, or a currency that is not a string, is a 422; a package that cannot be read is a 422 with INVALID_PACKAGE. Known bug: the handler reads order.id and order.secret while the service returns orderId and paymentIntentSecret, so the 200 body holds only ephemeralKey and customer; orderId and paymentIntentSecret are the intended fields and are not returned today. The package is not checked to be enabled, so a disabled package can be ordered by its id although the list shows only enabled ones. Any failure creating the payment intent is a 500, for example a currency the package has no price in, or a user with no Stripe customer id (nothing in the API sets one).')
    .pipe(userErrors);
const dispenseForUser = platform_1.HttpApiEndpoint.post('dispenseForUser') `/dispensing/dispense`
    .setPayload(Vending.DispenseForUserPayload)
    .addSuccess(CommandSentResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .middleware(openapi_1.Security.V1AuthenticatedUser)
    .annotate(platform_1.OpenApi.Title, 'Dispense As User')
    .annotate(platform_1.OpenApi.Description, `Sends a dispense command to a vending machine on behalf of the signed-in user. Invalid fields are a 422; a machine that is not found, or whose record cannot be read, is a 404. The user id is added to the command. The optional session id reaches only a V1 machine. ${accepted}`)
    .pipe(userErrors);
const dispenseWithOtp = platform_1.HttpApiEndpoint.post('dispenseWithOtp') `/dispensing/dispense/otp`
    .setPayload(Vending.DispenseWithSessionPayload)
    .addSuccess(CommandSentResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Dispense With Session Id')
    .annotate(platform_1.OpenApi.Description, `Sends a dispense command to a vending machine without a signed-in user. The session id is required and reaches only a V1 machine. ${otpSession} Invalid fields are a 422; a machine that is not found, or whose record cannot be read, is a 404. ${accepted}`)
    .pipe(openapi_1.Security.Public, publicErrors);
const dispenseWithSubscription = platform_1.HttpApiEndpoint.post('dispenseWithSubscription') `/dispensing/dispense/subscription`
    .setPayload(Vending.DispenseWithSessionPayload)
    .addSuccess(CommandSentResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(exports.NoActiveSubscriptions)
    .addError(openapi_1.Error.V1NotFound)
    .middleware(openapi_1.Security.V1AuthenticatedUser)
    .annotate(platform_1.OpenApi.Title, 'Dispense With Subscription')
    .annotate(platform_1.OpenApi.Description, `Sends a dispense command on behalf of a user with an active pelican subscription; the id of the first active subscription is added to the command. The session id reaches only a V1 machine. Checks run in this order: invalid fields are a 422; no active subscription is a 403 NO_ACTIVE_SUBSCRIPTIONS, so an unknown machine with no subscription gets 403; a machine that is not found, or whose record cannot be read, is a 404. ${accepted}`)
    .pipe(userErrors);
const washWithOtp = platform_1.HttpApiEndpoint.post('washWithOtp') `/aux/wash/otp`
    .setPayload(Vending.WashPayload)
    .addSuccess(CommandSentResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Wash With Session Id')
    .annotate(platform_1.OpenApi.Description, `Sends a bottle wash command to a vending machine without a signed-in user. The session id is required and is passed to the machine. ${otpSession} enhancements, waterType and volume are validated (a bad value is a 422) but ignored. A machine that is not found, or whose record cannot be read, is a 404. ${accepted}`)
    .pipe(openapi_1.Security.Public, publicErrors);
const washWithSubscription = platform_1.HttpApiEndpoint.post('washWithSubscription') `/aux/wash/subscription`
    .setPayload(Vending.WashPayload)
    .addSuccess(CommandSentResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(exports.NoActiveSubscriptions)
    .addError(openapi_1.Error.V1NotFound)
    .middleware(openapi_1.Security.V1AuthenticatedUser)
    .annotate(platform_1.OpenApi.Title, 'Wash With Subscription')
    .annotate(platform_1.OpenApi.Description, `Sends a bottle wash command on behalf of a user with an active pelican subscription; the id of the first active subscription is added to the command. enhancements, waterType and volume are validated (a bad value is a 422) but ignored. Checks run in this order: invalid fields are a 422; no active subscription is a 403 NO_ACTIVE_SUBSCRIPTIONS, so an unknown machine with no subscription gets 403; a machine that is not found, or whose record cannot be read, is a 404. ${accepted}`)
    .pipe(userErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.frontend.vending')
    .add(getDrinkList)
    .add(getStripeConfig)
    .add(listSubscriptionPackages)
    .add(getSubscriptionOrder)
    .add(createSubscriptionOrder)
    .add(dispenseForUser)
    .add(dispenseWithOtp)
    .add(dispenseWithSubscription)
    .add(washWithOtp)
    .add(washWithSubscription)
    .prefix('/vending')
    .annotate(platform_1.OpenApi.Title, 'Vending')
    .annotate(platform_1.OpenApi.Description, 'Vending machine endpoints: drink list, Stripe config, subscriptions, dispensing and washing')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.User));
//# sourceMappingURL=spec.js.map